function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.061 21.75a4.34 4.34 0 0 1-4.334-4.336V6.586A4.34 4.34 0 0 1 6.061 2.25h4.744a4.34 4.34 0 0 1 4.334 4.336v.907a.75.75 0 0 1-.75.75.75.75 0 0 1-.75-.75v-.907a2.838 2.838 0 0 0-2.834-2.836H6.061a2.838 2.838 0 0 0-2.834 2.836v10.828a2.838 2.838 0 0 0 2.834 2.836h4.753a2.828 2.828 0 0 0 2.825-2.824v-.918a.75.75 0 0 1 .75-.75.75.75 0 0 1 .75.75v.918a4.33 4.33 0 0 1-4.325 4.325zm11.557-6.383a.752.752 0 0 1 0-1.062l1.561-1.555h-9.9a.75.75 0 0 1-.75-.75.75.75 0 0 1 .75-.75h9.9l-1.561-1.555a.75.75 0 0 1 0-1.06.751.751 0 0 1 1.062 0l2.849 2.836a.75.75 0 0 1 .146.2v.007a.752.752 0 0 1 .07.3v.038a.75.75 0 0 1-.234.526l-2.835 2.823a.752.752 0 0 1-.529.219 2.643 2.643 0 0 1-.528-.217z"
});

function SvgLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout_icon.7f9c5cc8.svg";
export { ForwardRef as ReactComponent };